import type { Message } from '.';

export const cacheKey = (chatId: string) => `chat-messages-${chatId}`;

export const reviveDates = (messages: Message[]) =>
  messages.map(msg => ({
    ...msg,
    timestamp: new Date(msg.timestamp),
  }));

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const failSilently = (fn: Function) => {
  try {
    return fn();
  } catch (e) {
    // Do nothing
  }
};
